import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * 2210 - Mini Futures
 */
export const config2210: ProductTypeConfig = {
  code: '2210',
  name: 'Mini-Futures',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false,
        premium: true,
        basketOptionType: true,
        settlementType: true,
        denomination: false,
        leverage: true,
        ratio: true,
        stopLoss: true,
      },
    },
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.barrier.props,
        stopLoss: true,
        distanceStopLoss: true,
      },
      
    },
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        strikeLevel: false,
        strikeDistance: false,
      },
    },
  },
};
